import { createForOfIteratorHelperLoose as _createForOfIteratorHelperLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useTranslate } from '@awardit/react-use-translate';

var _excluded = ["company"];
var useFormatAddress = () => {
  var t = useTranslate();
  return addresses => {
    var billingUsedAsShipping = false;

    for (var _iterator = _createForOfIteratorHelperLoose(addresses), _step; !(_step = _iterator()).done;) {
      var _a = _step.value;

      if (_a.type === "billing" && _a.isUsedAsShipping) {
        billingUsedAsShipping = true;
        break;
      }
    }

    var a = addresses.find(x => x.type === (billingUsedAsShipping ? "billing" : "shipping"));

    if (a) {
      a.company;
          var rest = _objectWithoutPropertiesLoose(a, _excluded);

      var missingCompany = a.company === null || a.company === "";
      var missingAddressField = Object.values(rest).some(x => x === null || x === "");

      if (!missingAddressField && !missingCompany && a.company) {
        return `${a.firstname} ${a.lastname} (${a.company}), ${a.street[0]}, ${a.postcode} ${a.city}`;
      }

      if (!missingAddressField) {
        return `${a.firstname} ${a.lastname}, ${a.street[0]}, ${a.postcode} ${a.city}`;
      }
    }

    return /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#e44200"
      }
    }, t("CHECKOUT.ADDRESS.EMPTY_ADDRESS"));
  };
};

export { useFormatAddress };
//# sourceMappingURL=use-format-address.js.map
